<div class="item p-4 my-4">
  <div class="flex justify-between">
    <div class="flex flex-wrap md:flex-nowrap gap-2 md:gap-8 items-center">
      <div>
        @if (icon(); as logo) {
          <img
            [src]="'data:image/svg+xml;base64,' + logo"
            [alt]="ergebnis().versichererName"
            class="ml-4 w-28 h-14 md:min-w-32 md:h-16 object-contain"
          />
        }
      </div>

      <div>
        <div class="font-bold text-sm md:text-base">{{ ergebnis().versichererName }}</div>
        <div class="text-sm md:text-base">{{ ergebnis().name }}</div>

        <ng-content select="[left-side]" />
      </div>
    </div>

    <ng-content select="[right-side]" />
  </div>

  <div>
    <ng-content select="[actions]" />
  </div>
</div>
